import GetPersonalData from "../components/GetPersonalData";

export default function PersonalData() {
    return (
        <div>
            <GetPersonalData />
        </div>
    );
}
